import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "appointments-section mt-2" }
const _hoisted_2 = { class: "appointments-card" }
const _hoisted_3 = { class: "appointment-icon" }
const _hoisted_4 = { class: "appointment-copy" }
const _hoisted_5 = { class: "appointment-no" }
const _hoisted_6 = { class: "appointment-meta" }
const _hoisted_7 = { class: "appointment-status" }
const _hoisted_8 = { class: "status-label" }

import { computed } from "vue";

type SubscriptionDetailResponse = {
  appointments?: {
    id: string | number;
    appointment_no: string | null;
    appointment_date: string | null;
    appointment_time: string | null;
    status: string | null;
  }[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionDetailAppointmentsCard',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

function formatDateTime(dateValue: string | null, timeValue: string | null) {
  if (!dateValue) return "-";
  const date = new Date(`${dateValue}T${timeValue || "00:00:00"}`);
  if (Number.isNaN(date.getTime())) return "-";
  const datePart = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  const timePart = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
  return `${datePart} · ${timePart}`;
}

function statusMeta(status: string | null | undefined) {
  const key = String(status ?? "").trim().toLowerCase();
  switch (key) {
    case "booked":
      return { key: "booked", label: "Booked" };
    case "scheduled":
      return { key: "scheduled", label: "Scheduled" };
    case "completed":
      return { key: "completed", label: "Completed" };
    case "cancelled":
    case "canceled":
      return { key: "cancelled", label: "Cancelled" };
    default:
      return { key: "scheduled", label: "Scheduled" };
  }
}

const appointmentItems = computed(() =>
  (props.detail.appointments ?? []).map((item) => {
    const meta = statusMeta(item.status);
    return {
      id: item.id,
      appointmentNo: item.appointment_no || "-",
      scheduleLabel: formatDateTime(item.appointment_date, item.appointment_time),
      statusKey: meta.key,
      statusLabel: meta.label,
    };
  }),
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "appointments-section-title px-2" }, "Appointments", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointmentItems.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "appointment-row"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "deep-orange-darken-1"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-calendar-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.appointmentNo), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.scheduleLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", `status-dot--${item.statusKey}`])
            }, null, 2),
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.statusLabel), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})